module.exports = __webpack_public_path__ + "static/img/gz-dk-new.b63b15d3.png";